// src/stores/authStore.js
import { defineStore } from 'pinia';
import { ref } from 'vue';
import AuthService from "@/service/auth/AuthService";

export const useAuthStore = defineStore('authStore', () => {
    // 상태 정의
    const isLoggedIn = ref(false); // 로그인 상태
    const isLoggingOut = ref(false); // 로그아웃 진행 상태

    // 액션 정의
    const setLoginStatus = (status:boolean) => {
        isLoggedIn.value = status;
    };

    const startLogout = () => {
        isLoggingOut.value = true;
    };

    const finishLogout = () => {
        isLoggedIn.value = false;
        isLoggingOut.value = false;
        AuthService.IS_PROCESS_LOGOUT = false;
    };

    return {
        isLoggedIn,
        isLoggingOut,
        setLoginStatus,
        startLogout,
        finishLogout,
    };
});
